import { EClient } from "@/enums/EClient";
import { useAuthStore } from "@/stores";
import { useClientStore } from "@/stores/modules/client";
import { tokenError } from "./loginUtil";

const BOCOM_TEST = "https://paymenttest.bankcomm.com"
const BOCOM_PRODUCT = "https://creditcardapp.bankcomm.com"

export const authorizeBocomCode = (url: string, state: string = "1") => {
    //localStorage.setItem('JUMPS', params);
    //console.log(url);
    //const clientId = '8f54b1bf1db7447ab5695ebfd0bce7aa';
    const clientId = "mdb_to_mzyb";
    const api = import.meta.env.VITE_BOCOM_API || BOCOM_TEST;

    window.location.replace(`${api}/oautht/authorize?client_id=${clientId}&response_type=code&state=1&redirect_uri=${encodeURIComponent(
        url
    )}`);

};


export const checkBocomToken = async () => {

    const token = useAuthStore().getToken();
    const exipres = useAuthStore().expireTime

    if (useClientStore().client === EClient.BOCOM) {
        if (!token || exipres <= new Date().getTime()) {
            useAuthStore().clearToken()
            const searchStr = window.location.search.replace("?", "")

            const to = window.location.pathname.split("/").pop()

            const searchParam = searchStr ? `${searchStr.startsWith("&") ? searchStr : `&${searchStr}`}` : ""
            const state = `to=${to}${searchParam}`
            useClientStore().oauth(`/pages/bocom/oauth?to=${to}${searchParam}`, state)
            return Promise.reject(new Error('Token已过期'))
        }
    }
    return Promise.resolve();

}
